<template>
  <div>
    <div class="icon-text">
      <img :src="beforeSrc" alt="Icon" style="margin-right: 0px"> <!-- 使用 img 标签加载图片 -->
      <a class="n-line" :title="title" @click="toPath">【{{createtime}}】{{title}}</a>
    </div>
    <div v-if="showBottom" style="height: 3px;margin-bottom: 5px; border-bottom: 1px dashed #aaa; width: calc(100% - 36px); margin-left: 16px "></div>
  </div>
</template>

<script>
export default {
  name: "normal-article",
  props: {
    createtime: {
      type: String,
      default: '2024-11-25'
    },
    title: {
      type: String,
      default: ''
    },
    id: {},
    showBottom: {
      type: Boolean,
      default: true
    },
    beforeSrc: {
      default: require('@/assets/icon/a-t.png')
    }
  },
  methods: {
    toPath() {
      if(this.id) {
        this.$router.push({
          path: '/article-page/'+this.id
        })
      }
    }
  }
}
</script>

<style scoped>
.icon-text {
  display: flex;
  align-items: center;
  width: calc(100%); /* 可根据需要调整最大宽度 */
  font-size: 14px;
  line-height: 28px;

}

.n-line {
  width: calc(100% - 21px);
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.n-line:hover {
  color: #0f6ee2;
}
</style>
